<template>
  <card-modal
    :visible="visible"
    @close="close"
    :title="title"
  >
    <div style="position:relative">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="false"
      ></loading>
      <div class="field">
        <div class="control-label">
          <label class="label field-required">New Password</label>
        </div>
        <div class="control is-grouped">
          <p class="control is-expanded">
            <input
              v-validate="'required|min:6|max:255'"
              :class="{'is-danger': errors.has('password') }"
              name="password"
              v-model="password"
              class="input"
              type="text"
              placeholder="Enter password"
            >
            <span
              v-show="errors.has('password')"
              class="help is-danger"
            >{{ errors.first('password') }}</span>
          </p>
        </div>
      </div>
      <div class="mt-20">
        <save-button @click="save">

        </save-button>
      </div>
    </div>

  </card-modal>
</template>

<script>
  import CardModal from "views/components/modals/base/CardModal";
  import { eBus } from 'utils/eventbus'
  import mixin from "components/mixin";
  import config from "configSite";
  import { account } from "api";
  import loading from "vue-loading-overlay"
  export default {
    mixins: [mixin],
    components: {
      CardModal, 'loading': loading
    },
    props: {
      visible: Boolean,
      title: String,
    },
    data () {
      return {
        password: null,
        isLoading: false
      }
    },
    methods: {
      close () {
        eBus.$emit("close-modal");
      },
      save () {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.isLoading = true
            let result = {
              password: this.password
            }

            account
              .resetPassword(result)
              .then(res => {
                if (res.data.success) {
                  this.isLoading = false
                  this.openNotificationWithType("success", {
                    title: "Success",
                    message: "Update password successfully"
                  });
                  this.close()
                }
              })
              .catch(err => {
                this.isLoading = false
                this.formatShowError(err)
              })
          }
        })

      }
    },
    created () {

    }
  }
</script>

